import React from 'react';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { AccommodationArrangedStatusEnum } from 'api-paths-cas';
import { Badge, BadgeProps, Box } from '@chakra-ui/react';
import { getNotArrangedAccommodationTypeStatus } from '../../../../../utilities/helpers';

const ArrivalStatusFormatter = (cellProps: CellProps): React.JSX.Element => {
  const {
    row: { accommodationTypeStatus, accommodationArrangedStatus = 'None' },
  } = cellProps;

  const getStatus = (): BadgeProps => {
    switch (accommodationArrangedStatus) {
      case AccommodationArrangedStatusEnum.ARRANGED: {
        return { children: 'Arranged', colorScheme: 'green' };
      }
      case AccommodationArrangedStatusEnum.NOT_ARRANGED: {
        return { children: 'Not arranged', colorScheme: 'yellow' };
      }
      default: {
        return { children: 'None', variant: 'transparent' };
      }
    }
  };

  const { colorScheme, children, variant } = getStatus();

  return (
    <CellEventsHandler cellProps={cellProps}>
      <Box my={-1}>
        <Badge colorScheme={colorScheme} variant={variant}>
          {children}
        </Badge>

        {accommodationTypeStatus && accommodationArrangedStatus !== AccommodationArrangedStatusEnum.NONE && (
          <Box mt={1} noOfLines={2} color="muted" fontSize="xs" lineHeight="4">
            {accommodationArrangedStatus === AccommodationArrangedStatusEnum.NOT_ARRANGED
              ? getNotArrangedAccommodationTypeStatus(accommodationTypeStatus)
              : accommodationTypeStatus}
          </Box>
        )}
      </Box>
    </CellEventsHandler>
  );
};

export const AccommodationColumn = (): IColumn => ({
  item: {
    key: 'accommodationStatus',
    name: 'Accommodation status',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(160px, 1.25fr)',
    sortable: true,
    formatter: ArrivalStatusFormatter,
  },
  visible: ({ isAccStatusVisible }) => isAccStatusVisible!,
});
